module.exports = __webpack_public_path__ + "assets/cdd905903291a51f39b4ee0b00c4ff4f.mp3";